import * as React from "react";
import { OrderedSet } from "immutable";
import { Pages, PageDisplay } from "../../../../store/AppDisplays";
import { Menu, MenuItem, MenuOrientation } from "@vwpfs/mary-air-lib/components/air/07-organisms/Menu";

// StateProps are props derived from Redux state through MapStateToProps.
interface StateProps {
}

/**
 *
 */
interface OwnProps {
    tabs: OrderedSet<Pages>;
}

/**
 *
 */
interface DispatchProps {
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;


/**
 *
 */
export const DashboardMenu = (props: Props) => (
    <Menu
        orientation={MenuOrientation.VERTICAL}
        items={getItems(props)}
    />
);

/**
 *
 * @param props
 */
const getItems = (props: Props): MenuItem[] =>
    props.tabs
        .map((page: Pages): MenuItem => ({
            children: PageDisplay[page].title,
            navLink: PageDisplay[page].path,
        }))
        .toArray();
